import classNames from 'classnames';

interface IconProps {
    className?: string | null;
}

function Cadran({ className = null }: IconProps) {
    return (
        <svg
            className={classNames([{ [className]: className !== null }])}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 236.36 138.49"
        >
            <defs>
                <filter
                    id="drop-shadow-cadran"
                    x="0"
                    y="0"
                    width="236.36"
                    height="138.49"
                    filterUnits="userSpaceOnUse"
                >
                    <feOffset dx="5" dy="5" />
                    <feGaussianBlur result="blur" stdDeviation="0" />
                    <feFlood floodColor="#000" floodOpacity="1" />
                    <feComposite in2="blur" operator="in" />
                    <feComposite in="SourceGraphic" />
                </filter>
            </defs>
            <polygon
                points="52.42 124 2.75 89.73 62.69 82.72 46.67 24.54 97.09 57.69 122.21 2.83 139.53 60.64 194.04 34.76 170.14 90.17 228.54 105.39 174.61 132.47 52.42 124"
                fill="#928df7"
                filter="url(#drop-shadow-cadran)"
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
}

export default Cadran;
